export enum Actions {
  OPEN_DEVICE_CUSTOMIZATION = 'OPEN_DEVICE_CUSTOMIZATION',
  SET_DEVICE_CUSTOMIZATION_URL = 'SET_DEVICE_CUSTOMIZATION_URL'
}
